export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2018.8e0c8ed5.pdf";